module.exports = __webpack_public_path__ + "img/double-down.1b7b6deb.svg";